export const actionTypes = {
    SIGN_UP: 'SIGN_UP',
    SIGN_IN: 'SIGN_IN',
    SET_SESSION: 'SET_SESSION',
    GET_SESSION: 'GET_SESSION',
    SET_UNAUTHENTICATED: 'SET_UNAUTHENTICATED',
    SET_USER: 'SET_USER',
    SET_USER_PROFILE: 'SET_USER_PROFILE',
    GET_USER: 'GET_USER',
    GET_USER_PROFILE: 'GET_USER_PROFILE',
    UPDATE_USER: 'UPDATE_SER',    
    UPDATE_USER_FAVORITE_OPINIONS: 'UPDATE_USER_FAVORITE_OPINIONS',
    SET_LOADING: 'SET_LOADING',
    SET_SUBMITTING: 'SET_SUBMITTING',
    SET_SUCCESS: 'SET_SUCCESS',
    SET_ERROR: 'SET_ERROR',
    SET_DARK_THEME: 'SET_DARK_THEME',
    SET_ALL_OPINIONS: 'SET_ALL_OPINIONS',
    SET_MY_OPINIONS: 'SET_MY_OPINIONS',
    SET_FAVORITE_OPINIONS: 'SET_FAVORITE_OPINIONS',
    SET_USER_OPINIONS: 'SET_USER_OPINIONS',
    SET_SEARCH_OPINIONS: 'SET_SEARCH_OPINIONS',
    SET_OPINION: 'SET_OPINION',
    SET_ALL_OPINIONS_PAGE_COUNT: 'SET_ALL_OPINIONS_PAGE_COUNT',
    SET_ALL_OPINIONS_CURRENT_COUNT: 'SET_ALL_OPINIONS_CURRENT_COUNT',
    SET_ALL_OPINIONS_TOTAL_COUNT: 'SET_ALL_OPINIONS_TOTAL_COUNT',
    SET_MY_OPINIONS_PAGE_COUNT: 'SET_MY_OPINIONS_PAGE_COUNT',
    SET_MY_OPINIONS_CURRENT_COUNT: 'SET_MY_OPINIONS_CURRENT_COUNT',
    SET_MY_OPINIONS_TOTAL_COUNT: 'SET_MY_OPINIONS_TOTAL_COUNT',
    SET_FAVORITE_OPINIONS_PAGE_COUNT: 'SET_FAVORITE_OPINIONS_PAGE_COUNT',
    SET_FAVORITE_OPINIONS_CURRENT_COUNT: 'SET_FAVORITE_OPINIONS_CURRENT_COUNT',
    SET_FAVORITE_OPINIONS_TOTAL_COUNT: 'SET_FAVORITE_OPINIONS_TOTAL_COUNT',
    SET_USER_OPINIONS_PAGE_COUNT: 'SET_USER_OPINIONS_PAGE_COUNT',
    SET_USER_OPINIONS_CURRENT_COUNT: 'SET_USER_OPINIONS_CURRENT_COUNT',
    SET_USER_OPINIONS_TOTAL_COUNT: 'SET_USER_OPINIONS_TOTAL_COUNT',    
    SET_SEARCH_OPINIONS_PAGE_COUNT: 'SET_SEARCH_OPINIONS_PAGE_COUNT',
    SET_SEARCH_OPINIONS_CURRENT_COUNT: 'SET_SEARCH_OPINIONS_CURRENT_COUNT',
    SET_SEARCH_OPINIONS_TOTAL_COUNT: 'SET_SEARCH_OPINIONS_TOTAL_COUNT',    
    GET_OPINIONS: 'GET_OPINIONS',
    GET_SEARCH_OPINIONS: 'GET_SEARCH_OPINIONS',
    GET_OPINION: 'GET_OPINION',
    CREATE_OPINION: 'CREATE_OPINION',
    RESET_OPINION_REDUCER: 'RESET_OPINION_REDUCER',    
    CREATE_COMMENT: 'CREATE_COMMENT'
};